import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Adopt from './pages/Adopt';
import About from './pages/About';
import Volunteer from './pages/Volunteer';
import MedicalServices from './pages/services/MedicalServices';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adopt" element={<Adopt />} />
          <Route path="/adopt/*" element={<Adopt />} />
          <Route path="/about" element={<About />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/services/medical" element={<MedicalServices />} />
          
          {/* Stub routes for other pages - they'll show the appropriate main page */}
          <Route path="/services/*" element={<MedicalServices />} />
          <Route path="/foster" element={<Volunteer />} />
          <Route path="/donate" element={<About />} />
          <Route path="/events" element={<About />} />
          <Route path="/programs/*" element={<About />} />
          <Route path="/resources/*" element={<About />} />
          <Route path="/get-involved" element={<Volunteer />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
